import { Injectable } from "@angular/core";

import { QueryStringSerializationService } from "../../../../shared-library/services/environment/query-string-serialization.service";
import { SearchTabAlias } from "../../../enums/search-tab-alias.enum";
import { SearchParametersModel } from "../models/search-parameters.model";
import { DirectorySearchTabConfigModel } from "../models/directory-search-tab-config.model";

@Injectable({
    providedIn: "root"
})
export class DirectorySearchParametersFactoryService {
    public constructor(
        private _serializationService: QueryStringSerializationService
    ) {
    }

    public createFromQueryString(queryString: string, searchTabConfig: DirectorySearchTabConfigModel): SearchParametersModel {
        const rawValues = this._serializationService.deserialize<SearchParametersModel>(queryString);
        const parsedValues = new SearchParametersModel();

        parsedValues.searchTab = searchTabConfig.tabAlias;
        parsedValues.templateId = searchTabConfig.directoryTemplateId;

        if (rawValues.searchTab === searchTabConfig.tabAlias) {
            parsedValues.searchText = rawValues.searchText || "";
            parsedValues.sortOption = rawValues.sortOption || "Rank;asc";
            parsedValues.pageNumber = (rawValues.pageNumber > 0) ? Number(rawValues.pageNumber) : 1;
            parsedValues.pageSize = ((rawValues.pageSize > 0) && (rawValues.pageSize <= 100)) ? Number(rawValues.pageSize) : 10;

            if (parsedValues.sortOption.split(";").length !== 2) {
                parsedValues.sortOption = "Rank;asc";
            }

            parsedValues.categories = rawValues.categories || [];
            parsedValues.needsOfChildren = rawValues.needsOfChildren || [];
            parsedValues.postcodes = rawValues.postcodes || [];
            parsedValues.age = rawValues.age || [];
            parsedValues.frequency = rawValues.frequency || [];
            parsedValues.dietaryNeeds = rawValues.dietaryNeeds || [];
            parsedValues.accessibility = rawValues.accessibility || [];
            parsedValues.provisionTypes = rawValues.provisionTypes || [];
            parsedValues.schoolNeeds = rawValues.schoolNeeds || [];
            parsedValues.specialDietCater = rawValues.specialDietCater || [];
            parsedValues.postcode = rawValues.postcode || "";
            parsedValues.distance = rawValues.distance || "1609"; // 1 mile converted to meters
            parsedValues.startDate = rawValues.filters?.startDate;
            parsedValues.endDate = rawValues.filters?.endDate;
        } else {
            parsedValues.searchText = rawValues.searchText || "";
            parsedValues.sortOption = "Rank;asc";
            parsedValues.pageNumber = 1;
            parsedValues.pageSize = 10;

            parsedValues.postcode = "";
            parsedValues.distance = "1609"; // 1 mile converted to meters
        }

        if (SearchTabAlias.EVENTS_SEARCH === searchTabConfig.tabAlias) {
            parsedValues.sortOption = "Occurrence;asc";
        }

        return parsedValues;
    }

    public serialiseToQueryString(searchParams: SearchParametersModel): string {
        return this._serializationService.serialize(searchParams);
    }
}
